import React from "react";
import { RichText } from "./RichText";

export const FinePrints = ({ finePrints }) => {
  return (
    <section className="container">
      <div className="row">
        <div className="col-12 col-lg-7 py-3rem">
          {finePrints.map((finePrint, index) => (
            <RichText
              className="fs-0_875 "
              key={index}
              text={finePrint.description.raw}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
